import React, { useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import * as S from "./styles";

const PasswordInput = ({
  label,
  inputName = "password",
  registerFunction,
  errors,
  variant = "dark",
}) => {
  const [showPassword, setShowPassword] = useState(false);

  if (!label || typeof inputName !== "string" || !registerFunction) return null;

  const error = !!errors && errors[inputName];

  return (
    <div className="password-input-container">
      <S.InputContainer>
        <S.InputTextFieldContainer invalid={!!error} variant={variant}>
          <label htmlFor={inputName}>{label}</label>
          <input
            {...registerFunction(inputName)}
            aria-invalid={error ? "true" : "false"}
            type={showPassword ? "text" : "password"}
            autoComplete="on"
          />
        </S.InputTextFieldContainer>
        <S.InputIconContainer data-testid="password-toggle">
          <S.IconButtonContainer
            onClick={(e) => {
              e.preventDefault();
              setShowPassword(!showPassword);
            }}
            tabIndex="-1"
            role="button"
          >
            {showPassword ? <FiEyeOff /> : <FiEye />}
          </S.IconButtonContainer>
        </S.InputIconContainer>
      </S.InputContainer>

      {error && (
        <S.ErrorMessage variant={variant}>{error.message}</S.ErrorMessage>
      )}
    </div>
  );
};

export default PasswordInput;
